var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnackbarSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#41B7A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33918 9.86613C6.93052 9.49462 6.29807 9.52474 5.92656 9.9334C5.55506 10.3421 5.58517 10.9745 5.99383 11.346L7.33918 9.86613ZM8.74984 12.5L8.07716 13.24L8.74984 13.8515L9.42251 13.24L8.74984 12.5ZM14.0058 9.07328C14.4145 8.70178 14.4446 8.06933 14.0731 7.66067C13.7016 7.25201 13.0692 7.2219 12.6605 7.5934L14.0058 9.07328ZM5.99383 11.346L8.07716 13.24L9.42251 11.7601L7.33918 9.86613L5.99383 11.346ZM9.42251 13.24L14.0058 9.07328L12.6605 7.5934L8.07716 11.7601L9.42251 13.24Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnackbarSuccess);
export default __webpack_public_path__ + "static/media/snackbarSuccess.527ed43229b4b9e41340c0af347bc6c3.svg";
export { ForwardRef as ReactComponent };